export const SITE_URL = 'https://triptomorrow.ru';

export const TELEGRAM_URL = 'https://t.me/triptomorrow';

export const TELEGRAM_OFFERS_URL = 'https://t.me/TripTomorrowOffers';

export const YANDEX_METRIKA_ID = 102209215;

/**
 * Якорь блока выбора направления на главной (#230). Живёт здесь, а не рядом с
 * героем: на него ссылается и герой, и сам блок, и общий модуль тянет в
 * клиентский бандл меньше, чем компонент с фоновым видео и картинками.
 */
export const PICKER_ANCHOR = 'pick';
